export default "__VITE_ASSET__BUoBnzwP__"